var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircleRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.458,
    height: 26.458,
    viewBox: "0 0 26.458 26.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.049,11.024A11.024,11.024,0,1,1,11.024,0,11.024,11.024,0,0,1,22.049,11.024Z",
    transform: "translate(2.205 2.205)",
    fill: "rgba(41,45,50,0.1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M5.113,3.944,7.648,1.408A.826.826,0,0,0,6.48.24L3.944,2.775,1.408.24A.826.826,0,0,0,.24,1.408L2.775,3.944.24,6.48a.832.832,0,0,0,0,1.169.825.825,0,0,0,1.169,0L3.944,5.113,6.48,7.648a.825.825,0,0,0,1.169,0,.832.832,0,0,0,0-1.169Z",
    transform: "translate(9.285 9.285)",
    fill: "#e70202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H26.458V26.458H0Z",
    fill: "none",
    opacity: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleRed);
export default __webpack_public_path__ + "static/media/close-circle-red.d580681acbe3acc2bace56c2a20b0fda.svg";
export { ForwardRef as ReactComponent };